import React from 'react';

function Hero({ variant, title, tagline, showSocial }) {
  const getHeroClass = () => {
    const baseClass = 'hero';
    switch (variant) {
      case 'about':
        return `${baseClass} about-hero`;
      case 'location':
        return `${baseClass} location-hero`;
      case 'loyalty':
        return `${baseClass} loyalty-hero`;
      default:
        return baseClass;
    }
  };

  return (
    <section className={getHeroClass()}>
      <div className="hero-content">
        <h1>{title}</h1>
        <p className="tagline" dangerouslySetInnerHTML={{ __html: tagline }} />
        {showSocial && (
          <div className="social-link">
            <a href="https://instagram.com/groundedcoffee_co" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i> @GROUNDEDCOFFEE_CO
            </a>
          </div>
        )}
      </div>
    </section>
  );
}

export default Hero;

